<template>
  <div class="relative">
    <div class="absolute right-3 top-3">
      <div
        @click="downLoad()"
        class="px-4 py-2 cursor-pointer flex items-center gap-2 text-xs rounded-2xl bg-white/20 backdrop-blur-md text-white"
      >
        Learn more <HelpSvg />
      </div>
    </div>
  </div>
  <section class="flex flex-col items-center justify-center py-14">
    <div>
      <img
        src="@/assets/images/logo.png"
        alt="IWC Logo"
        class="h-20 w-20 object-contain"
      />
    </div>
    <div class="text-3xl font-black text-white text-center space-y-1">
      <h1>Automated</h1>
      <h1>Member's Availment</h1>
      <h1>Portal</h1>
    </div>
    <form
      @submit.prevent="verifyHandler()"
      class="pt-12 flex flex-col justify-center gap-3"
    >
      <h4 class="text-white text-sm text-left">Enter IWC Card</h4>

      <input
        required
        placeholder="e.g. ABC-X-1000"
        v-model="passkey"
        type="text"
        class="h-14 w-full px-4 py-3 rounded-xl bg-white/20 backdrop-blur-md border border-white/30 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-white/40 focus:bg-white/25 transition appearance-none"
      />
      <h4 class="text-white text-sm text-left">Enter Birthdate</h4>
      <input
        required
        v-model="birthdate"
        type="date"
        class="h-14 w-full px-4 py-3 rounded-xl bg-white/20 backdrop-blur-md border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-white/40 focus:bg-white/25 transition appearance-none"
      />

      <button
        class="my-2 py-3 w-full rounded-md bg-orange-600 text-white text-base font-semibold shadow-lg hover:opacity-90 active:scale-95 transition duration-200"
      >
        <span v-if="!isLoading">Verify</span>

        <span v-else class="flex items-center justify-center gap-2">
          <LoadingSVG />
          initializing...
        </span>
      </button>
    </form>
  </section>
  <div class="flex justify-center items-center">
    <SemanticVersion />
  </div>
</template>
<script>
import HelpSvg from "@/components/svgs/HelpSvg.vue";
import { inject, onMounted, ref, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
export default {
  components: {
    HelpSvg,
  },
  name: "AuthView",

  setup() {
    const router = useRouter();
    const publicId = ref();
    const axios = inject("$axios");
    const store = inject("$store");
    const Swal = inject("$swal");
    const isLoading = ref(false);

    const formData = reactive({
      passkey: null,
      birthdate: null,
    });

    onMounted(() => {});

    const verifyHandler = async () => {
      try {
        isLoading.value = true;

        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        const { data } = await axios.post(
          `/meta/api/amap/ims/user/verify`,
          formData
        );

        if (data.token) {
          await delay(2000);
          isLoading.value = false;
          localStorage.setItem(process.env.VUE_APP_AUTH_TOKEN, data.token);
          store.commit("getUserLogged", data.data);
          router.push(`/auth/home`);
        }
      } catch (error) {
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        await delay(2000);
        isLoading.value = false;

        if (error.response.status === 404) {
          Swal.fire({
            icon: "error",
            title: "Invalid IWC Card",
            text: "Your IWC card is invalid. Please make sure you input the correct IWC card.",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Invalid Birthdate",
            html: `
 The birthdate you entered does not match our records.<br><br>
    Please make sure to enter it correctly. Otherwise,
    <span id="birthdate-link" style="color:#3085d6; text-decoration: underline; cursor:pointer;">
      click here
    </span>
    to update.
  `,
            confirmButtonText: "OK",
            didOpen: () => {
              const link = document.getElementById("birthdate-link");
              if (link) {
                publicId.value = error.response.data.data.publicId;
                link.addEventListener("click", () => {
                  router.push(`/amap/birthdate/form/${publicId.value}`);
                  Swal.close();
                });
              }
            },
          });
        }
      }
    };

    const downLoad = () => {
      const url = "https://iwcsrvr.com/user-guide/amap-guide.pdf";

      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer"; // security best practice
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    return {
      publicId,
      verifyHandler,
      ...toRefs(formData),
      isLoading,
      downLoad,
    };
  },
};
</script>
